import "preact/debug";
import {h, render, Component} from 'preact';
import Config_base from "../awrabet/config";
import Config_hrf from "../harifsport/config.jsx";
import Config_j from "../jamibet/config";
import Config from "./config";
import { setMobileHeader } from "../jamibet/mobile-pages/full-site";
import CustomMobileHeader from "./mobile-components/site/mobile-header";
setMobileHeader(CustomMobileHeader);
import Template from './index.jsx';
import PageDataFeed from '../../services/page-data-feed';
import Localization from "../jamibet/utils/localization";
import Ticket from "../../services/ticket";

import * as iFrame from "../jamibet/utils/iframeResizer.contentWindow.min.js";
import { registerGoogleTagModule } from "../../utils/gtm-module";
window.iFrameResizer = {
	targetOrigin: '*'
};

registerGoogleTagModule('G-R8WBY3E59S');

Ticket.canBeSystem = () => false;
Ticket.conflictStrategy = (odd) => {
    const key = `/odd/${odd.id.split('/')[2]}`;
    if (Ticket.hasOddsOfEvent(key)) {
        Array.from(Ticket.data.odds).filter(odd => odd.indexOf(key+'/') > 0).forEach(odd => {
            Ticket.tmpToggleOdd(odd);
        });
        if (odd.live)
            Ticket.tmpToggleLiveOdd(odd.id);
        else
            Ticket.tmpTogglePrematchOdd(odd.id);
    }
}

class App extends Component {
    state = {};

    componentWillMount() {
        document.title = Config.title;
        PageDataFeed.rerender = () => this.setState({});

		let params = (new URL(document.location)).searchParams;
		Config.publickey = Config.publickey || params.get('public');
		if (Config.publickey != null && document.location.origin.indexOf('/iframe.') > 0) {
			Config.softionAPI = document.location.origin.replace('/iframe.', '/api-new.');
			Config.reservedPrintAPI = Config.reservedPrintAPI.replace('{softionApi}', Config.softionAPI);
		}
		if (Config.publickey != null) {
			Config.setSkin(Config.publickey);
		}
    }

    render() {
        return <Template config={{}} />;
    }
}

render(<Localization><App /></Localization>, document.getElementById('app-root'));

(function () {
	const throttle = function (type, name, obj) {
		obj = obj || window;
		let running = false;
		const func = function () {
			if (running) {
				return;
			}
			running = true;
			requestAnimationFrame(function () {
				obj.dispatchEvent(new CustomEvent(name));
				running = false;
			});
		};
		obj.addEventListener(type, func, {passive: true});
	};
	/* init - you can init any event */
	throttle("resize", "optimizedResize");
	throttle("scroll", "optimizedScroll");
})();

window.addEventListener('optimizedResize', () => {
	PageDataFeed.readPageWidth();
});

// <script type="text/javascript" src="https://botsailor.com/script/tme-link.js?code=172157522986079"></script>



//> Eof